import { useMutation } from '@tanstack/react-query';
import {
  type SendMfaOtpCodeRequestDto,
  type SendMfaOtpCodeResponseDto,
  sendTwoFactorIdentityCode,
} from '@/features/user-settings-phone/api';

const useSendTwoFactorIdentityCode = ({
  onSuccess,
}: {
  onSuccess: (data: SendMfaOtpCodeResponseDto) => void;
}) => {
  const mutation = useMutation({
    mutationFn: (data: SendMfaOtpCodeRequestDto) => {
      return sendTwoFactorIdentityCode(data);
    },
    onSuccess,
  });

  return {
    sendTwoFactorIdentity: mutation.mutateAsync,
    isSendTwoFactorIdentityLoading: mutation.isPending,
    isSendTwoFactorIdentityError: mutation.isError,
    sendTwoFactorIdentityError: mutation.error,
  };
};

export { useSendTwoFactorIdentityCode };
